var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoanApplicationsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.42 19.9998H6.01001V15.5898L19.01 2.58984L23.42 6.99982L10.42 19.9998ZM8.01001 17.9998H9.59003L20.59 6.99982L19.01 5.40979L8.01001 16.4098V17.9998Z",
    fill: "url(#paint0_linear_3151_4920)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71719 14.2879L7.30298 15.7021L10.3011 18.7003L11.7153 17.2861L8.71719 14.2879Z",
    fill: "url(#paint1_linear_3151_4920)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H0V0H17V4H15V2H2V22H15V17H17V24Z",
    fill: "url(#paint2_linear_3151_4920)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H4V6H12V4Z",
    fill: "url(#paint3_linear_3151_4920)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H4V10H9V8Z",
    fill: "url(#paint4_linear_3151_4920)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H4V14H6V12Z",
    fill: "url(#paint5_linear_3151_4920)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3151_4920",
    x1: 14.715,
    y1: 21.6119,
    x2: 14.715,
    y2: 0.332995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3151_4920",
    x1: 11.2858,
    y1: 18.2708,
    x2: 7.62144,
    y2: 14.6064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3151_4920",
    x1: 8.5,
    y1: 26.2222,
    x2: 8.5,
    y2: -3.11111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3151_4920",
    x1: 8,
    y1: 6.18519,
    x2: 8,
    y2: 3.74074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3151_4920",
    x1: 6.5,
    y1: 10.1852,
    x2: 6.5,
    y2: 7.74074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3151_4920",
    x1: 5,
    y1: 14.1852,
    x2: 5,
    y2: 11.7407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanApplicationsActive);
export default __webpack_public_path__ + "static/media/loan-applications-active.e683b78c6c84918277e20abf098c8180.svg";
export { ForwardRef as ReactComponent };